import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';

const NotifiModal = ({ notify, close }) => {
  const initStyles = {
    overlay: { backgroundColor: 'rgba(36, 39, 42, 0.3)' },
    modal: {
      padding: 0,
      minWidth: '416px',
      width: '416px',
      maxWidth: 'unset',
      borderRadius: '4px',
      boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.08)',
      border: 'solid 1px #eaeeef',
      opacity: '1'
    }
  };

  return (
    <Modal
      open={notify?.open}
      onClose={close}
      center
      styles={initStyles}
      classNames={{
        overlay: 'modal-overflow-overLay',
        modal: 'custom-pdf-modal invoice-review-modal comment-modal inv-report-notify',
        closeIcon: 'custom-close',
        closeButton: 'custom-close-btn'
      }}
    >
      <div className="m-header invoice-review-header">
        <div className="m-title">{notify?.success ? 'Success' : 'Oops'}</div>
      </div>
      <div className="m-body pdf-modal-custom-view invoice-review-body comment-body">
        <div>{notify?.message}</div>
        <button className="protean-btn protean-btn-default mx-auto" type="button" onClick={close}>
          Okay
        </button>
      </div>
    </Modal>
  );
};

NotifiModal.propTypes = {
  notify: PropTypes.instanceOf(Object).isRequired,
  close: PropTypes.func.isRequired
};

export default NotifiModal;
